import { getLocaleFromPathname } from '@/shared/utils/i18n/locale-path';

export const setBestGuessAddress = async (): Promise<void> => {
  try {
    // The handler cannot read the site locale itself; outside React the pathname is the source.
    const locale = getLocaleFromPathname(window.location.pathname);
    await fetch(`/api/cart/best-guess-address?locale=${locale}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      cache: 'no-store',
    });
  } catch (_) {
    console.debug('no best guess', _);
  }
};
